import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

//Interfaces
import { IRoom } from 'src/app/entities/interfaces/configuration/IRoom';

@Injectable({
  providedIn: 'root'
})
export class RoomService {
  token: string = sessionStorage.token;

  constructor(private http: HttpClient) { }
  GetAll(idCompany: string, idPremise: string): Observable<any> {
    let token: string = sessionStorage.token;

    const headers = new HttpHeaders({
      'Authorization': token
    });

    const uri = environment.pathBackEnd.concat(`room/GetAll.php?idCompany=${idCompany}&idPremise=${idPremise}`);
    return this.http.get<any>(uri, { headers });
  }
  GetActives(idCompany: string, idPremise: string): Observable<any> {
    let token: string = sessionStorage.token;

    const headers = new HttpHeaders({
      'Authorization': token
    });

    const uri = environment.pathBackEnd.concat(`room/GetActives.php?idCompany=${idCompany}&idPremise=${idPremise}`);
    return this.http.get<any>(uri, { headers });
  }
  Create(idCompany: string, idPremise: string, row: IRoom): Observable<any> {
    let token: string = sessionStorage.token;

    const headers = new HttpHeaders({
      'Authorization': token
    });
    const body = { ...row, idCompany, idPremise };
    const uri = environment.pathBackEnd.concat("room/Create.php");
    return this.http.post<any>(uri, body, { headers });
  }
  Update(idCompany: string, idPremise: string, row: IRoom): Observable<any> {
    let token: string = sessionStorage.token;

    const headers = new HttpHeaders({
      'Authorization': token
    });

    const body = { ...row, idCompany, idPremise };
    const uri = environment.pathBackEnd.concat("room/Update.php");
    return this.http.put<any>(uri, body, { headers });
  }
  /**
   * Swagger: DELETE /room/Delete.php
   * Importante: el backend lee idRoom de $_GET (query string), NO del body.
   * Si se envía solo en el body, idRoom queda null y el UPDATE no afecta
   * ninguna fila (pero igual responde status:true → confunde al frontend).
   */
  Delete(idRoom: number): Observable<any> {
    let token: string = sessionStorage.token;
    const headers = new HttpHeaders({ 'Authorization': token });
    const uri = environment.pathBackEnd.concat(`room/Delete.php?idRoom=${idRoom}`);
    return this.http.request<any>('DELETE', uri, { headers, body: { idRoom } });
  }
}